import cookies from "../../utils/cookies";
import {useNavigateTo} from "../../hooks/useNavigateTo";
import {useDispatch} from "react-redux";
import {setDrawerLogin} from "../../reducer/actions";
import {useProduceCoupon} from "../../api/couponReceive";

export default function CouponCardHOC(Wrapper) {
  
  return function (props) {
    const navigateTo = useNavigateTo();
    const dispatch = useDispatch();
    const { recevierCouponHandle } = useProduceCoupon();
    
    const getCoupon = async (couponId) => {
      if (!cookies.getToken()) {
        if (cookies.get('MALL') != 7) {
          return navigateTo('/login');
        } else {
          return dispatch(setDrawerLogin(true));
        }
      } else {
        
        let q = {
          couponId,
        };
        let { data } = await recevierCouponHandle(q);
        
        if (data) {
          console.log(data, 'data');
        }
      }
    };
    
    return <Wrapper {...props} getCoupon={getCoupon}/>;
  };
}
